import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast, Toaster } from "react-hot-toast";
import axios from "axios";
import logo from "../assets/images/logo.jpg";
import config from "../config";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // ✅ Email validation function
  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Input validation
    if (!email.trim()) {
      return toast.error("Email is required!");
    }
    if (!validateEmail(email)) {
      return toast.error("Enter a valid email address!");
    }

    try {
      setLoading(true);
      await axios.post(`${config.API_BASE_URL}/api/auth/forgot-password`, {
        email,
      });
      toast.success("Check your email for reset link");
      setTimeout(() => {
        navigate("/login");
      }, 4000); // 3 seconds delay
    } catch (err) {
      toast.error(err.response?.data?.error || "Error sending reset email");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <Toaster position="top-center" />
      <div className="w-full max-w-md bg-white shadow-lg rounded-2xl p-8">
        {/* Logo at the top */}
        <div className="flex justify-center mb-4">
          <img
            src={logo}
            alt="Company Logo"
            className="h-16 w-16 object-cover rounded-full"
          />
        </div>

        <h1 className="text-3xl font-bold text-center mb-6 text-[#007AFF]">
          Forgot Password
        </h1>

        <p className="text-center text-gray-600 mb-6">
          Enter your email to receive a password reset link.
        </p>

        <form className="space-y-6" onSubmit={handleSubmit}>
          <div>
            <label className="block text-gray-700 font-medium mb-2">
              Email
            </label>
            <input
              type="email"
              placeholder="Enter your email"
              className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#007AFF] outline-none"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className={`w-full py-3 rounded-lg font-semibold transition ${
              loading
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-[#007AFF] text-white hover:bg-blue-600"
            }`}
          >
            {loading ? "Sending..." : "Send Reset Link"}
          </button>
        </form>

        <p className="mt-6 text-center text-gray-600">
          Back to{" "}
          <Link to="/login" className="text-[#007AFF] hover:underline">
            Login
          </Link>
        </p>
      </div>
    </div>
  );
}
